<template>
  <div class="Other_box">
    <p style="color: #333333;margin-bottom: 10px;">其他配件及家居家纺产品规格 <span style="font-weight: bold;">请根据产品的具体类型</span> 填写：</p>
    <el-input v-model="Value" placeholder="请填写您的产品规格"
              show-word-limit
              type="textarea"
              maxlength="200"
              style="width: 100%;"
              :autosize="{ minRows: 6, maxRows: 8}"
              @input="OtherTitle"></el-input>
    <p style="margin-top: 10px;">备注说明：床单/被罩需填写产品尺寸，例如200*230cm。</p>
  </div>
</template>

<script>
export default {
  name: "OtherProducts",
  props: {
    LocalKey: {
      type: String,
      default: () => ''
    }
  },
  data(){
    return {
      Value:''
    }
  },
  mounted() {
    let SelectTypeSize=JSON.parse(localStorage.getItem(this.LocalKey))
    if(SelectTypeSize&&SelectTypeSize.Size){
      for(let i in SelectTypeSize.Size){
        if(SelectTypeSize.Size[i].name==='OtherProducts'){
          this.Value=SelectTypeSize.Size[i].list
        }
      }
    }
  },
  methods:{
    OtherTitle(){
      let SelectTypeSize=JSON.parse(localStorage.getItem(this.LocalKey))
      let list={
        name:'OtherProducts',
        list:this.Value
      }
      if(SelectTypeSize&&SelectTypeSize.Size){
        let Index=SelectTypeSize.Size.findIndex(item=>{
          return item.name==='OtherProducts'
        })
        if(Index<0){
          SelectTypeSize.Size.push(list)
        }else{
          SelectTypeSize.Size[Index]=list
        }
        localStorage.setItem(this.LocalKey,JSON.stringify(SelectTypeSize))
      }else{
        localStorage.setItem(this.LocalKey,JSON.stringify({
          Size:[list]
        }))
      }
    }
  }
}
</script>

<style scoped>

</style>